import { PRODUCT_MODULES } from '../../presentation/productModules';
import type { PresentationModule } from '../../presentation/types';
import { sharedDna } from './content';
import { SharedDnaScene } from './scenes/SharedDnaScene';

export const sharedCapabilitiesModule: PresentationModule = {
  id: 'shared-capabilities',
  label: 'Shared capabilities',
  priority: 'structural',
  scenes: [
    { ...sharedDna, module: 'shared-capabilities', requiresAny: PRODUCT_MODULES, create: (resolved) => new SharedDnaScene(resolved) },
  ],
};
